import {SharedOrderResponse} from '../models/shared-order.model';

export const dataToSharedOrderResponse = (data: any): SharedOrderResponse => new SharedOrderResponse(
  data.location_id,
  data.merchant_id,
  data.shared_order_id,
  data.status,
);
